import { Reveal } from "./Reveal";

const PARAGRAPHS = [
  "I’m pursuing Computer Science Engineering at Shiv Nadar University, where I’m developing my understanding of software, systems, and problem-solving.",
  "I’m interested in more than just writing code. I enjoy exploring how ideas become products, how technology can solve practical problems, and how different fields can come together to create something useful.",
  "That curiosity has taken me in different directions, from exploring biometric payments through BioPay to experimenting with atmospheric water generation.",
  "Outside technology, football and endurance challenges have become important parts of my journey. They have given me opportunities to compete, test my limits, and develop discipline beyond the classroom.",
  "I enjoy learning by doing, whether that means building a prototype, exploring a new idea, or taking on a challenge that pushes me beyond what feels comfortable.",
];

export const About = () => (
  <section id="about" data-testid="about-section" className="py-24 md:py-32 lg:py-40">
    <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
      <div className="lg:col-span-4">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#71717A] font-mono-alt">About</p>
          <h2 className="font-heading text-4xl md:text-5xl tracking-tight leading-tight font-medium text-[#F9F9F9] mt-4">
            A little about me.
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-7 lg:col-start-6 space-y-6">
        {PARAGRAPHS.map((p, i) => (
          <Reveal key={i} delay={i * 0.08}>
            <p
              data-testid={`about-paragraph-${i}`}
              className={`leading-relaxed ${i === 0 ? "text-lg md:text-xl text-[#F9F9F9]" : "text-base md:text-lg text-[#A1A1AA]"}`}
            >
              {p}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
